import { forwardRef } from 'react';

export const LogoFilled = forwardRef<
  SVGSVGElement,
  React.ComponentPropsWithoutRef<'svg'>
>(({ color = 'currentColor', ...props }, ref) => (
  <svg
    ref={ref}
    fill='none'
    viewBox='0 0 246 143'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.6 143c-2.8 0-4.4-1.8-4.4-4.6v-.4c0-2.4 1-4 3.2-5.2 10.2-4.6 12-7.4 12-22V32.2c0-14.6-1.8-17.4-12-22C1.2 9 .2 7.4.2 5v-.4C.2 1.8 1.8 0 4.6 0H60c2.8 0 4.6 1.8 4.6 4.6V5c0 2.4-1 4-3.4 5.2-10 4.6-11.8 7.4-11.8 22v88.6c0 6 6.6 9.8 18.4 9.8h2.4c15.2 0 28-20.2 30.8-26.2 1.2-2.4 2.8-4.8 6.4-4.8 3.4 0 5.4 2.6 5 6.8l-3.6 32.6c-.4 2.2-2.4 4-4.6 4H4.6Zm118.758 0c-2.8 0-4.4-1.8-4.4-4.6v-.4c0-2.4 1-4 3.2-5.2 10.2-4.6 12-7.4 12-22V32.2c0-14.6-1.8-17.4-12-22-2.2-1.2-3.2-2.8-3.2-5.2v-.4c0-2.8 1.6-4.6 4.4-4.6h67.6c27.6 0 46.6 13.4 46.6 32.8 0 12.4-8.4 21.6-19.2 25.2-2.8.8-4.2 2.4-4.2 3.8 0 1.8 1.6 3.4 4.4 4 15.2 3.8 26.8 17.4 26.8 36.6 0 24-22.8 40.6-56.2 40.6h-65.8Zm61.6-13.8c16.8 0 24.4-8.2 24.4-25.6 0-20.4-8.4-31.6-24.8-31l-10.4.4c-3.6.2-6 3-6 6.4V119c0 7.2 6.4 10.2 16.8 10.2Zm-11.6-70.8h8.4c13.8 0 22-10.6 22-23.4 0-12.6-7.6-21.4-21.4-21.4h-8.4c-3.4 0-5.8 2.8-5.8 6.4v32c0 3.6 2.4 6.4 5.2 6.4Z'
      fill={color}
    />
  </svg>
));
